import { TextField } from '@mui/material'
import {
    EAdminReportPermissions,
    EClientPermissions,
    EEducatorPermissions,
    EInspectionPermissions,
    EMedicalPermissions,
    EReportPermissions,
} from '@Enum/auth.enum'
import { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { connect } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import * as Redux from 'redux'
import { ToastServices } from '@Services/toast.service'
import { FormService } from '@Services/form.service'
import { IRootStates } from '../../../models/store.model'
import AuthAction from '../../../store/auth/auth.action'
import AuthLayout from '../AuthLayout'

const defaultValues = {
    username: '',
    password: '',
}

interface ILogin {
    login: (body: any) => Promise<any>
    getAuthorization: () => Promise<any>
    user?: any
    logout: () => void
}

const Login = (props: ILogin) => {
    // core section
    const { login, getAuthorization, logout, user } = props
    const history = useHistory()
    const ac = new AbortController()
    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm({ defaultValues })
    const classesInput = 'material-input material-input-width mb-4'

    useEffect(() => {
        if (!user?.role) return
        if (user?.permissions?.includes(EClientPermissions.LOGIN)) {
            history.push('/dashboard')
        } else if (user?.permissions?.includes(EEducatorPermissions.LOGIN)) {
            history.push('/home')
        } else if (user?.permissions?.includes(EReportPermissions.LOGIN)) {
            history.push('/report')
        } else if (user?.permissions?.includes(EAdminReportPermissions.LOGIN)) {
            history.push('/admin/report')
        } else {
            ToastServices.error('Unknown user!')
            logout()
        }
        return () => {
            ac.abort()
        }
    }, [])

    // functions section
    const handleRegisterClicked = () => {
        history.push('/register')
    }

    const onSubmit = (formData: any) => {
        getAuthorization().then(() => {
            login(formData).then((response) => {
                if (
                    response?.data?.user?.permissions?.includes(
                        EClientPermissions.LOGIN
                    )
                ) {
                    history.push('/dashboard')
                } else if (
                    response?.data?.user?.permissions?.includes(
                        EEducatorPermissions.LOGIN
                    )
                ) {
                    history.push('/dashboard')
                } else if (
                    response?.data?.user?.permissions?.includes(
                        EMedicalPermissions.LOGIN
                    )
                ) {
                    history.push('/medical-home')
                } else if (
                    response?.data?.user?.permissions?.includes(
                        EInspectionPermissions.LOGIN
                    )
                ) {
                    history.push('/inspection-info')
                } else if (
                    response?.data?.user?.permissions?.includes(
                        EReportPermissions.LOGIN
                    )
                ) {
                    history.push('/report')
                } else if (
                    response?.data?.user?.permissions?.includes(
                        EAdminReportPermissions.LOGIN
                    )
                ) {
                    history.push('/admin/report')
                } else {
                    ToastServices.error('Unknown user!')
                }
            })
        })
    }

    // main section
    return (
        <AuthLayout>
            <div className="auth-bg login-form">
                <p className="auth-headline">LOG IN</p>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Controller
                        control={control}
                        name="username"
                        defaultValue=""
                        rules={{ required: true }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <TextField
                                {...field}
                                value={value}
                                onChange={onChange}
                                inputRef={ref}
                                label="User Name"
                                variant="standard"
                                className={classesInput}
                                error={errors?.username && true}
                                helperText={FormService.getErrorMessage(
                                    errors,
                                    'username',
                                    'Product Name'
                                )}
                            />
                        )}
                    />

                    <Controller
                        control={control}
                        name="password"
                        defaultValue=""
                        rules={{ required: true, minLength: 8 }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <TextField
                                {...field}
                                value={value}
                                onChange={onChange}
                                type="password"
                                variant="standard"
                                inputRef={ref}
                                label="Password"
                                className={classesInput}
                                error={errors?.password && true}
                                helperText={FormService.getErrorMessage(
                                    errors,
                                    'password',
                                    'Password',
                                    'Password should contain 8 characters'
                                )}
                            />
                        )}
                    />

                    <button type="submit" className="auth-primary-btn">
                        Login
                    </button>
                </form>

                <Link to="/" className="forgot-pwd-link d-block mt-4">
                    Forgot Password
                </Link>

                <button
                    type="button"
                    className="auth-secondary-btn mt-5"
                    onClick={handleRegisterClicked}
                >
                    Register
                </button>
            </div>
        </AuthLayout>
    )
}

const mapStateToProps = (state: IRootStates) => {
    const { user } = state.auth
    return { user }
}

// store section
const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    const { getAuthorization, login, logout } = AuthAction
    return {
        getAuthorization: () => dispatch(getAuthorization() as any),
        login: (userLogin: any) => dispatch(login(userLogin) as any),
        logout: () => dispatch(logout() as any),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)
